import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'
import app from './routers/Apps'
import login from './routers/Login'
import components from './routers/components'
import store from "@/store";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home/LandingPage.vue'),
      meta: { layout: 'full', resource: 'Auth', requiresAuth: false, redirectIfLoggedIn: true },
    },
    ...app,
    ...login,
    ...components,

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

/* ── Chunk load error handler ─────────────────────────────────────
 * Quando um novo deploy substitui os JS chunks, usuarios com a
 * versao antiga no cache recebem "ChunkLoadError". Esse handler
 * forca um reload unico para buscar os novos chunks.             */
router.onError((error) => {
  const isChunkError = /loading chunk|failed to fetch dynamically imported|ChunkLoadError/i.test(error.message)
  if (isChunkError) {
    const lastReload = sessionStorage.getItem('chunk_reload')
    const now = Date.now()
    // Evita loop infinito: so reloada 1x a cada 30s
    if (!lastReload || now - Number(lastReload) > 30000) {
      sessionStorage.setItem('chunk_reload', String(now))
      window.location.reload()
    }
  }
})

const SUPER_ADMIN_EMAIL = 'edvomberto@gmail.com'
function isSuperAdmin() {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}')
    const email = (u.user_email || u.email || '').toLowerCase()
    return email === SUPER_ADMIN_EMAIL
  } catch { return false }
}

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })
    // If logged in => not authorized
    // return next({ name: 'misc-not-authorized' })
  }

  // Bloqueia rotas de administração para não-super-admin
  if (to.meta.superAdminOnly && !isSuperAdmin()) {
    return next({ name: 'DashboardChat' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.user_role : null))
  }

  store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', to.name)
  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (!appLoading) return

  function hideLoading() {
    appLoading.style.opacity = '0'
    appLoading.style.transition = 'opacity 0.3s ease'
    setTimeout(() => { appLoading.style.display = 'none' }, 300)
  }

  // Espera ate que os estilos estejam prontos verificando se um elemento
  // do layout ja tem as dimensoes corretas (indica CSS carregado)
  function checkReady() {
    // Verifica se o #app tem conteudo renderizado com estilos
    const app = document.getElementById('app')
    const hasContent = app && app.offsetHeight > 100
    // Verifica se algum stylesheet chunk foi carregado (alem dos inline)
    const sheets = document.styleSheets.length
    return hasContent && sheets > 3
  }

  let attempts = 0
  const maxAttempts = 40 // 40 x 50ms = 2s maximo

  function tryHide() {
    attempts++
    if (checkReady() || attempts >= maxAttempts) {
      requestAnimationFrame(() => requestAnimationFrame(hideLoading))
    } else {
      setTimeout(tryHide, 50)
    }
  }

  tryHide()
})

export default router
